var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNullType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.354 2.354l-.707-.707-3.436 3.435C16.743 2.595 14.505 1 12 1 7.589 1 4 5.935 4 12a14.024 14.024 0 0 0 1.3 5.993l-3.654 3.653.707.707 3.436-3.435C7.257 21.405 9.495 23 12 23c4.411 0 8-4.935 8-11a14.024 14.024 0 0 0-1.3-5.993zM5 12C5 6.486 8.14 2 12 2c2.222 0 4.202 1.492 5.486 3.807L6.05 17.242A13.23 13.23 0 0 1 5 12zm14 0c0 5.514-3.14 10-7 10-2.222 0-4.202-1.492-5.486-3.807L17.95 6.758A13.23 13.23 0 0 1 19 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullType);
export default __webpack_public_path__ + "static/media/nullType.7ae44b432f29b4f8b0c7156ac695c685.svg";
export { ForwardRef as ReactComponent };